class editprojectInfoCtrl {
    constructor($scope, logger, httpRequest, $state, formvalidateApi, $rootScope, $stateParams) {
        $scope.isEdit = false
        if ($stateParams.projectId) {
            $scope.isEdit = true
        }
        $scope.userType = $rootScope.userInfo.user.userType
        $scope.addProjectInfo = {}
        $scope.beginDatetimepicker = {
            autoclose: true,
            minView: 'month',
            language: 'zh-CN',
            format: 'yyyy-mm-dd',
            forceParse: 0,
            pickTime: false
        }
        $scope.endDatetimepicker = {
            autoclose: true,
            minView: 'month',
            language: 'zh-CN',
            format: 'yyyy-mm-dd',
            forceParse: 0,
            pickTime: false
        }
        function reset() {
            if (!$scope.isEdit) {
                $scope.addProjectInfo = Object.assign($scope.addProjectInfo,{
                    projectCode: '',
                    projectName: '',
                    projectAddress: '',
                    startTime: '',
                    endTime: '',
                    projectLeader: '',
                    contact: '',
                    status: 1,
                    remark: ''
                })
            }
        }
        reset()
        function validateProject() {
            const mark = formvalidateApi.run()
            if (!mark) {
                return false
            }
            return true
        }
        $scope.addProject = function addProject(isContinue) {
            if (validateProject($scope.addProjectInfo)) {
                if (!$scope.isEdit) {
                    httpRequest.post_addProject({...$scope.addProjectInfo, orgId: $scope.addProjectInfo.orgId === -2 ? -1 : $scope.addProjectInfo.orgId}, '添加信息成功').then(() => {
                        if (isContinue) {
                            reset()
                        } else {
                            $scope.cancle()
                        }
                    }, () => {
                    })
                } else {
                    httpRequest.post_modProject($scope.addProjectInfo, '修改信息成功').then(() => {
                        $scope.cancle()
                    }, () => {
                    })
                }
            }
        }

        $scope.cancle = function cancle() {
            $state.go('system.basedata.projectInfo.list')
        }


        $scope.validateRules = {
            projectCode: [{
                erromsg: '限制15个字符以内',
                condition(value) {
                    let result = true
                    if (value.length > 15) result = false
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }, ],
            projectName: [{
                erromsg: '限制15个字符以内',
                condition(value) {
                    let result = true
                    if (value.length > 15) result = false
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }, ],
            projectAddress: [{
                erromsg: '限制50个字符以内',
                condition(value) {
                    let result = true
                    if (!value) {
                        return false
                    }
                    if (value.length > 50) result = false
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }, ],
            projectLeader: [{
                erromsg: '限制15个字符以内',
                condition(value) {
                    let result = true
                    if (!value) {
                        return false
                    }
                    if (value.length > 15) result = false
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            },],
            contact: [{
                erromsg: '限制15个字符以内',
                condition(value) {
                    let result = true
                    if (!value) {
                        return false
                    }
                    if (value.length > 15) result = false
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            },],
            remark: [{
                erromsg: '限制50个字符以内',
                condition(value) {
                    let result = true
                    if (!value) {
                        return false
                    }
                    if (value.length > 50) result = false
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }, ],
        }
        //获取机构列表
        httpRequest.get_organization(0).then((res) => {
            $scope.orgList = res.data.value
            $scope.orgList.unshift({
                orgId: -2,
                orgName: '全部机构',
                parentOrgId: -1,
                treeLevelCode: '0',
            })
            if ($scope.isEdit) {
                httpRequest.get_getProjectById($stateParams.projectId).then(res => {
                    $scope.addProjectInfo = res.data.value
                    for (var i = 0; i < $scope.orgList.length; i++) { 
                        if ($scope.orgList[i].orgId == $scope.addProjectInfo.orgId) {
                            $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]]
                        }
                    }
                })
            } else {
                for (var i = 0; i < $scope.orgList.length; i++) {
                    if ($scope.orgList[i].orgId == $stateParams.orgId && $scope.userType == 0) {
                        $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]]
                        $scope.addProjectInfo.orgId = $scope.orgList[i].orgId
                        break
                    }
                    if ($scope.orgList[i].orgId == JSON.parse($rootScope.userInfo.user.currentOrgId) && $scope.userType != 0) {
                        $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]]
                        $scope.addProjectInfo.orgId = $scope.orgList[i].orgId
                        break
                    }
                }
            }
        })
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'radioTree',
            parentIdName: 'parentOrgId',
            multiple: false,
            parentId: -1,
            defaultSelect: [],
        }
        // 机构变化
        $scope.orgSelectChange = function (v) {
            $scope.queryOrgConfig.defaultSelect = v
            $scope.addProjectInfo.orgId = v[0].orgId
        }

        $scope.$watch('addProjectInfo.startTime', (val) => {
            if(!val) return
            $('#project-endDate').find('input').datetimepicker('setStartDate', val)
        }, true)

        $scope.$watch('addProjectInfo.endTime', (val) => {
            if(!val) return
            $('#project-startDate').find('input').datetimepicker('setEndDate', val)
        }, true)
    }
}

editprojectInfoCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', 'formvalidateApi', '$rootScope', '$stateParams']
export default editprojectInfoCtrl


// WEBPACK FOOTER //
// ./src/app/system/basedata/projectInfo/editprojectInfoCtrl.js